module.exports = {"name":"xterm.fit","main":"fit.js","private":true}


//////////////////
// WEBPACK FOOTER
// /tmp/binderhub/node_modules/xterm/lib/addons/fit/package.json
// module id = 12
// module chunks = 0